'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeInDown = {
  from: {
    opacity: 0,
    transform: (0, _utils.translate3d)(0, '-100%', 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInDown;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/fade-in-down.js
// module id = 210
// module chunks = 54990529738226 257444579329143